module.exports = __webpack_public_path__ + "static/EuclidTriangle-Regular-WebS-1a6c9fbd090e60253dd35965a302b1b6.woff2";